import { render, staticRenderFns } from "./KrInput.vue?vue&type=template&id=546f9e46&"
import script from "./KrInput.vue?vue&type=script&lang=js&"
export * from "./KrInput.vue?vue&type=script&lang=js&"
import style0 from "./KrInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports